import { styled } from '@mui/material';
import { css, keyframes } from '@emotion/react';
import { marginLeft } from 'utils';

const slideTo30PX = keyframes`
  from {
    bottom: -100px;
  }
  to {
    bottom: 30px;
  }
`;

const slideTo90PX = keyframes`
  from {
    bottom: -100px;
  }
  to {
    bottom: 90px;
  }
`;

export const StyledContainer = styled('div')(
  ({ theme, fixed }) =>
    css`
      .rated-feedback {
        max-width: 360px;
        width: 100%;
        padding: 17px 14px;
        border-radius: 8px;
        background-color: #cafdf5;
        position: relative;
        z-index: ${theme.zIndex.snackbar};

        ${fixed &&
        css`
          position: fixed;
          bottom: 30px;
          animation: ${slideTo30PX} 0.3s ease forwards;
          transform: translateX(-50%);
          left: calc(50%);
        `}

        .close-button {
          position: absolute;
          top: 17px;
          left: 14px;
          color: ${theme.palette.primary.main};
        }
      }

      ${theme.breakpoints.down('md')} {
        height: 140px;
        position: relative;
        top: -65px;
        margin-bottom: 10px;

        .rated-feedback {
          ${fixed &&
          css`
            position: fixed;
            bottom: 90px;
            animation: ${slideTo90PX} 0.3s ease forwards;
            left: 50%;
          `}
        }
      }

      ${theme.breakpoints.down('sm')} {
        .rated-feedback {
          max-width: unset;
          width: calc(100% - 35px);
        }
      }
    `
);

export const StyledTitle = styled('div')(
  ({ theme }) =>
    css`
      color: ${theme.palette.primary.darker};
      font-size: ${theme.typography.subtitle2.fontSize};
      font-weight: ${theme.typography.subtitle2.fontWeight};
      line-height: ${theme.typography.subtitle2.lineHeight};
      ${marginLeft('44px')}
    `
);

export const StyledDescription = styled('div')(
  ({ theme }) =>
    css`
      color: ${theme.palette.secondary.light};
      font-size: ${theme.typography.captionLight.fontSize};
      font-weight: ${theme.typography.captionLight.fontWeight};
      line-height: ${theme.typography.captionLight.lineHeight};
      margin-bottom: 16px;
    `
);

export const StyledRateItems = styled('div')(
  () =>
    css`
      display: flex;
      direction: ltr;
      justify-content: center;
      gap: 8px;
    `
);

export const StyledRateItem = styled('div')(
  ({ theme, active }) =>
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 40px;
      border-radius: 8px;
      color: ${theme.palette.primary.darker};
      background-color: ${theme.palette.naturals.white};
      font-size: ${theme.typography.subtitle.fontSize};
      font-weight: ${theme.typography.subtitle.fontWeight};
      line-height: ${theme.typography.subtitle.lineHeight};
      border: 1px solid transparent;
      transition: all 0.3s ease;

      &:hover {
        border: 1px solid ${theme.palette.primary.darker};
        cursor: pointer;
      }

      ${active &&
      css`
        border: 1px solid ${theme.palette.primary.darker};
      `}
    `
);

export const StyledButtonWrapper = styled('div')(
  ({ theme }) =>
    css`
      display: flex;
      justify-content: center;
      margin-top: 8px;

      .MuiButton-root {
        color: ${theme.palette.primary.dark} !important;
        font-size: ${theme.typography.subtitle2.fontSize} !important;
        font-weight: ${theme.typography.subtitle2.fontWeight} !important;
        line-height: 20px !important;
      }
    `
);

export const StyledThanks = styled('div')(
  ({ theme }) =>
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      gap: 16px;

      .circle {
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .outer-circle {
        background-color: #ecfdf3;
        width: 70px;
        height: 70px;
      }
      .inner-circle {
        background-color: #dbfae6;
        width: 50px;
        height: 50px;
      }

      .heart-icon {
        color: ${theme.palette.info.dark};
      }

      .success-message {
        color: #000;
        font-size: ${theme.typography.subtitle2.fontSize};
        font-weight: ${theme.typography.subtitle2.fontWeight};
        line-height: ${theme.typography.subtitle2.lineHeight};
        margin: 0;
      }
    `
);
